<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import (Create or Update) Clients"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create or update clients."
      @on-submit="createClientImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Clients Template.xlsx"
              :file-provider="$importsAPI.getClientsTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ClientsImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'clients-imports-add-modal',
    };
  },
  methods: {
    createClientImport(data, handleCreate) {
      handleCreate(this.$importsAPI.clientsCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
